module.exports = __webpack_public_path__ + "static/media/facebook_cinza.2c2cac47.svg";